<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { useConfigStore } from '../../stores/config'
import { useClient } from '../../utils/client-only'

import type { ComposedPageMeta } from '@xcel-next/composer-schema'

const props = defineProps<{
  pageMeta?: ComposedPageMeta
}>()

const { isClient } = useClient()
const { rsConfig } = storeToRefs(useConfigStore())

const isEnabled = computed(() => !!(props.pageMeta?.vgWortTrackingId && rsConfig.value.vgWort?.enabled && rsConfig.value.vgWort?.url))
const trackingUrl = computed(() => `${rsConfig.value.vgWort?.url}${props.pageMeta?.vgWortTrackingId}`)
</script>

<template>
  <div class="bx-vgwort"
       data-tc="vg-wort">
    <img v-if="isClient && isEnabled"
         :src="trackingUrl"
         height="1"
         width="1">
  </div>
</template>
